export default __webpack_public_path__ + "locales/vi/FormFillingTipsDialog.json?hash=9eec291eb73aa15056d8112415ae7678";